import API from './config'

export const LegislationArticleAPI = {

    async createLegislationSegment(legislationSegment) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/legislationArticles/createLegislationSegment', legislationSegment, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getResolutionVersions() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/legislationArticles/getResolutionVersions', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getResolutionVersionIdByDate(date) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/legislationArticles/getResolutionVersionIdByDate?date=' + date, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listLegislationSegments() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/legislationArticles/listLegislationSegments', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listLegislationSegmentsByVersionId(resolutionVersionId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/legislationArticles/listLegislationSegmentsByVersionId/' + resolutionVersionId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listLegislationSegmentsByDate(date) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/legislationArticles/listLegislationSegmentsByDate', { date }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listLegislationSegmentsByType(type) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/legislationArticles/listLegislationSegmentsByType/' + type, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async createNewLegislationArticle(legislationSegment) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/legislationArticles/createLegislationArticle', legislationSegment, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateLegislationSegment(segmentId, legislationSegment) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/legislationArticles/updateLegislationSegment/' + segmentId,
                legislationSegment, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateLegislationArticle(articleId, legislationArticle) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/legislationArticles/updateLegislationArticle/' + articleId,
                legislationArticle, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listAllLegislationArticles() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/legislationArticles/listAllLegislationArticles', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listAllLegislationArticlesByResolutionId(resolutionId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/legislationArticles/listAllLegislationArticlesByResolution/' + resolutionId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listLegislationArticlesBySegment(type) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/legislationArticles/listLegislationArticlesBySegment/' + type, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error);
            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listLegislationArticles(type, clientId, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/legislationArticles/listLegislationArticles', {
                legislation_segment_id: type,
                client_id: clientId,
                year: year,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listLegislationArticlesByDate(type, clientId, year, date, orderBySegment) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/legislationArticles/listLegislationArticlesByDate', {
                legislation_segment_id: type,
                client_id: clientId,
                year: year,
                date: date, //data que indicará quais artigos devem ser trazidos (versão da resolução)
                order_by_segment: orderBySegment,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listLegislationArticlesByType(type, clientId, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/legislationArticles/listLegislationArticlesByType', {
                legislation_segment_id: type,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getArticlesByCnpjList(cnpjs, month, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/legislationArticles/getArticlesByCnpjList', { cnpjs: cnpjs, month, year }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async proccessAndCheckNonComplienceArticles(clientId, simpleNormalizedAssets, month, yearToSelect, pronagementCode) {

        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const { data: response } = await API.post(`/legislationArticles/proccessAndCheckNonComplienceArticles`, {
                client_id: clientId,
                assets: simpleNormalizedAssets,
                month: month,
                year: yearToSelect,
                pronagement_code: pronagementCode,
            }, config)

            return {
                success: true,
                ...response
            };

        } catch (error) {

            console.log("Error: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }

    }
}
